<template>
  <div id="system-journal-setting-general-setting">
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SUBMISSION_SETTING')">
      <div class="ipub-h2 lin-h-40 mar-b-10">Submission Setting</div>
      <div class="ipub-block">
        <ipub-radio-group v-model="submissionSetting"
                          :disabled="!(user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SUBMISSION_SETTING.EDIT'))"
                          @change="submissionHandle"
                          :options="options" />

      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Article Type Alert
        <span class="ipubw-p2"
              v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT.APLY_TO_ALL_JOURNALS')">
          <ipub-icon type="iconapplytoglobal"
                     class="mar-l-20 ipub-cursor-pointer"
                     v-if="dataSource && dataSource.length>0"
                     @click="copy()" />
          <ipub-icon type="iconapplytoglobal"
                     class="mar-l-20 line-color"
                     v-else />
        </span>
        <a class="link-color ipub-p2 mar-l-10"
           v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT.ADD')"
           @click="add">
          <ipub-icon type="iconAdd" /> Add New Alert
        </a>
      </div>
      <div>
        <div v-for="(item,index) in dataSource"
             :key="item.id+index">
          <div class="flex content-bg mar-b-10"
               style="justify-content: space-between;align-items: center;padding:10px;">
            <div class="ipub-p2 fw-bd"
                 style="width:120px;text-align:right">
              <span v-if="item.symbolType"> {{symbol[item.symbolType]}}</span> {{item.number}} / {{item.type}}
            </div>
            <div style="width:calc(100% - 260px);float:left;overflow:hidden"
                 class="mar-l-20">
              <div style="margin-right:10px;float:left;align-items: center;"
                   class="ipub-p4 flex"
                   v-for="(itemType,indexType) in item.articleTypeList"
                   :key="itemType.id+indexType">{{itemType.name}}<template v-if="itemType.otherName"> ({{itemType.otherName}})</template>
                <div class="min-line mar-l-10"></div>
              </div>
            </div>
            <div class="ipub-p2 mar-l-20 flex"
                 style="width:100px;font-size:16px;align-items: center;">
              <ipub-icon type="iconEditPen"
                         class="ipub-cursor-pointer"
                         v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT.EDIT')"
                         @click="edit(item)" />
              <div class="min-line mar-l-10"></div>
              <ipub-icon type="iconduplicate"
                         class="mar-l-10 ipub-cursor-pointer"
                         v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT.APLY_TO_ALL_JOURNALS')"
                         @click="copy(item)" />
              <div class="min-line mar-l-10"></div>
              <ipub-icon type="iconDelete"
                         class="mar-l-10 ipub-cursor-pointer"
                         @click="del(item)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_DATE_ALERT')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Article Date Alert
        <span class="ipubw-p2 mar-l-16 ipub-cursor-pointer"
              v-if="!isEdit.date">
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_DATE_ALERT.ADD')"
                     type="iconEditPen"
                     class="border-right"
                     style="padding-right:10px"
                     @click="editAble('date')" />
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_DATE_ALERT.APLY_TO_ALL_JOURNALS')"
                     type="iconapplytoglobal"
                     class="mar-l-10"
                     @click="copy('dateAlert')" />
        </span>
      </div>
      <div class=" ipub-block"
           v-if="isEdit.date">
        <div class="flex mar-b-20"
             style="align-items:center">
          <span>Received Date</span>
          <div class="line mar-l-20"></div>
          <div class="mar-l-20 ipub-p2 flex"
               style="min-width:120px;align-items:center">
            <ipub-input style="width:60px;padding:0 12px"
                        v-model="params.RECEIVED_REVISED_DATE"
                        number
                        :fixed="0"
                        placeholder=""></ipub-input> Days
          </div>
          <div class="line mar-l-20"></div> <span class="mar-l-20">Revised Date</span>
          <div class="line mar-l-20"></div>
          <div class="mar-l-20 ipub-p2 flex"
               style="min-width:120px;align-items:center">
            <ipub-input style="width:60px;padding:0 12px"
                        v-model="params.REVISED_ACCEPT_DATE"
                        number
                        min="0"
                        :fixed="0"
                        placeholder=""></ipub-input> Days
          </div>
          <div class="line mar-l-20"></div> <span class="mar-l-20">Accepted Date</span>
          <div class="line mar-l-20"></div>
          <div class="mar-l-20 ipub-p2 flex"
               style="min-width:120px;align-items:center">
            <ipub-input style="width:60px;padding:0 12px"
                        number
                        :fixed="0"
                        v-model="params.ACCEPT_PUBLISHED_DATE"
                        placeholder=""></ipub-input> Days
          </div>
          <span class="mar-l-20">Published Date</span>
        </div>
        <div>
          <ipub-button plain
                       type="primary"
                       size="small"
                       :style="{minWidth: '150px'}"
                       @click="cancel">Cancel</ipub-button>
          <ipub-button type="primary"
                       size="small"
                       :style="{minWidth: '150px'}"
                       @click="confirmArticleDate()">Save</ipub-button>
        </div>
      </div>
      <div v-else>
        <div class="flex ipub-block ipub-p2"
             style="align-items:center">
          <span class="fw-bd">Received Date</span>
          <div class="line mar-l-20"></div> <span class="mar-l-20 ipub-p2">{{alertDate.RECEIVED_REVISED_DATE}} Days</span>
          <div class="line mar-l-20"></div> <span class="mar-l-20 fw-bd">Revised Date</span>
          <div class="line mar-l-20"></div> <span class="mar-l-20 ipub-p2">{{alertDate.REVISED_ACCEPT_DATE}} Days</span>
          <div class="line mar-l-20"></div> <span class="mar-l-20 fw-bd">Accepted Date</span>
          <div class="line mar-l-20"></div> <span class="mar-l-20 ipub-p2">{{alertDate.ACCEPT_PUBLISHED_DATE}} Days</span>
          <span class="mar-l-20 fw-bd">Published Date</span>
        </div>
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.UNSUBSCRIBED_EFFECTIVE_DAYS')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Unsubscribed Effective Days
        <span class="ipubw-p2 mar-l-16 ipub-cursor-pointer"
              v-if="!isEdit.UNSUBSCRIBED_EFFECTIVE_DATE">
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.UNSUBSCRIBED_EFFECTIVE_DAYS.EDIT')"
                     type="iconEditPen"
                     class="border-right"
                     style="padding-right:10px"
                     @click="editAble('UNSUBSCRIBED_EFFECTIVE_DATE')" />
        </span>
      </div>
      <div class="ipub-block">
        <template v-if="isEdit.UNSUBSCRIBED_EFFECTIVE_DATE">
          <div class="flex mar-b-20">
            <ipub-input style="width:300px"
                        placeholder="Input Unsubscribed Effective"
                        number
                        :fixed="0"
                        v-model="params.UNSUBSCRIBED_EFFECTIVE_DATE" />
            <div class="line-h-40 mar-l-10">Days</div>
          </div>
          <div>
            <ipub-button plain
                         type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="cancel">Cancel</ipub-button>
            <ipub-button type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="confirmSetting('UNSUBSCRIBED_EFFECTIVE_DATE')">Save</ipub-button>
          </div>
        </template>
        <div v-else>
          {{alertDate.UNSUBSCRIBED_EFFECTIVE_DATE || 0}} Days
        </div>
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_VOUCHER')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Discount Voucher
        <span class="ipubw-p2 mar-l-16 ipub-cursor-pointer"
              v-if="!isEdit.discountVoucher">
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_VOUCHER.EDIT')"
                     type="iconEditPen"
                     class="border-right"
                     style="padding-right:10px"
                     @click="editAble('discountVoucher')" />
        </span>
        <span class="ipub-p2 link-color mar-l-16 ipub-cursor-pointer"
              v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_VOUCHER.ADD')"
              @click="addDiscountVoucher">
          <ipub-icon type="iconAdd" />Add New Voucher
        </span>
      </div>
      <div>
        <div v-if="isEdit.discountVoucher"
             class="ipub-block ipub-p2">
          <div class="flex mar-b-10"
               v-for="item in discountVoucherList"
               :key="item.id">
            <ipub-input style="width:100px"
                        placeholder="Input Unsubscribed Effective"
                        number
                        :fixed="0"
                        v-model="item.discount" />
            <span class="line-h-40 mar-l-10">USD
              <ipub-icon type="iconDelete"
                         v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_VOUCHER.DELETE')"
                         @click="delDiscountVoucher(item)"
                         class="mar-l-10 ipub-c-p" />
            </span>
          </div>
          <div>
            <ipub-button plain
                         type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="cancel">Cancel</ipub-button>
            <ipub-button type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="confirmDiscountVoucher()">Save</ipub-button>
          </div>
        </div>
        <div class="flex"
             v-else>
          <div class="flex mar-b-10 content-bg ipub-p2"
               style="margin-right:12px;padding:6px 12px"
               v-for="item in discountVoucherList"
               :key="item.id">
            $ {{item.discount}} off
            <span class="ipubw-p2">
              <ipub-icon type="iconDelete"
                         @click="delDiscountVoucher(item)"
                         class="mar-l-10 ipub-c-p" />
            </span>
          </div>
        </div>
      </div>

    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_DAY')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Validity Period of Discount Voucher
        <span class="ipubw-p2 mar-l-16 ipub-cursor-pointer"
              v-if="!isEdit.DISCOUNT_DAY">
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_DAY.EDIT')"
                     type="iconEditPen"
                     class="border-right"
                     style="padding-right:10px"
                     @click="editAble('DISCOUNT_DAY')" />
        </span>
      </div>
      <div class="ipub-block">
        <template v-if="isEdit.DISCOUNT_DAY">
          <div class="flex mar-b-20">
            <ipub-input style="width:300px"
                        placeholder="Input Unsubscribed Effective"
                        number
                        :fixed="0"
                        v-model="params.DISCOUNT_DAY" />
            <div class="line-h-40 mar-l-10">Days</div>
          </div>
          <div>
            <ipub-button plain
                         type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="cancel">Cancel</ipub-button>
            <ipub-button type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="confirmSetting('DISCOUNT_DAY')">Save</ipub-button>
          </div>
        </template>
        <div v-else>
          {{alertDate.DISCOUNT_DAY || 0}} Days
        </div>
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_TOPIC_ON_WEBSITE')">
      <div class="ipub-h2 lin-h-40 mar-b-10">Topics</div>
      <div class="ipub-block">
        <ipub-radio :checked="displayTopic"
                    :disabled="!(user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_TOPIC_ON_WEBSITE.EDIT'))"
                    @change="(e) => {confirmSetting('DISPLAY_TOPIC',e)}"
                    label="Show Topics" />
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SPECIAL_ISSUE_SHOW')">
      <div class="ipub-h2 lin-h-40 relative mar-b-10 flex"
           style="height:40px;align-items:center">
        Special Issue Show
        <span class="ipubw-p2 mar-l-16 ipub-cursor-pointer"
              v-if="!isEdit.SPECIAL_ISSUE_SHOW">
          <ipub-icon v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SPECIAL_ISSUE_SHOW.EDIT')"
                     type="iconEditPen"
                     class="border-right"
                     style="padding-right:10px"
                     @click="editAble('SPECIAL_ISSUE_SHOW')" />
        </span>
      </div>
      <div class="ipub-block">
        <template v-if="isEdit.SPECIAL_ISSUE_SHOW">
          <ipub-row :gutter="[50,10]">
            <ipub-col :span="1"
                      class="ipub-block_special_issue_show">
              Open SI
            </ipub-col>
            <ipub-col :span="8"
                      class="flex-center">
              Planned Papers ≥
              <ipub-input style="width:100px"
                          class="mar-l-10 inline-block "
                          placeholder="Input Unsubscribed Effective"
                          number
                          :fixed="0"
                          v-model="params.SPECIAL_OPEN_PLAN_NUM" />
              <span class="mar-l-10"> articles or Published Papers ≥</span>
              <ipub-input style="width:100px"
                          class="mar-l-10 inline-block"
                          placeholder="Input Unsubscribed Effective"
                          number
                          :fixed="0"
                          v-model="params.SPECIAL_OPEN_PUBLISH_NUM" />
              <span class="mar-l-10"> articles or use the single special issue setting</span>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[50,20]">
            <ipub-col :span="1"
                      class="ipub-block_special_issue_show">Closed SI</ipub-col>
            <ipub-col :span="8"
                      class="flex-center">Planned papers ≥
              <ipub-input style="width:100px"
                          class="mar-l-10 inline-block"
                          placeholder="Input Unsubscribed Effective"
                          number
                          :fixed="0"
                          v-model="params.SPECIAL_CLOSE_PLAN_NUM" />
              <span class="mar-l-10"> articles or published papers ≥</span>
              <ipub-input style="width:100px"
                          class="mar-l-10 inline-block"
                          placeholder="Input Unsubscribed Effective"
                          number
                          :fixed="0"
                          v-model="params.SPECIAL_CLOSE_PUBLISH_NUM" />
              <span class="mar-l-10"> articles or use the single special issue setting</span>
            </ipub-col>
          </ipub-row>

          <div>
            <ipub-button plain
                         type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="cancel">Cancel</ipub-button>
            <ipub-button type="primary"
                         size="small"
                         :style="{minWidth: '150px'}"
                         @click="confirmSetting('SPECIAL_ISSUE_SHOW')">Save</ipub-button>
          </div>
        </template>
        <div v-else>
          <ipub-row :gutter="[20, 20]">
            <ipub-col :span="1">Open SI</ipub-col>
            <ipub-col :span="11">Planned papers ≥ {{alertDate.SPECIAL_OPEN_PLAN_NUM || 0}} articles or published papers ≥ {{alertDate.SPECIAL_OPEN_PUBLISH_NUM || 0}} articles or use the single special issue setting</ipub-col>
          </ipub-row>
          <ipub-row :gutter="[20]">
            <ipub-col :span="1">Closed SI</ipub-col>
            <ipub-col :span="11">Planned papers ≥ {{alertDate.SPECIAL_CLOSE_PLAN_NUM || 0}} articles or published papers ≥ {{alertDate.SPECIAL_CLOSE_PUBLISH_NUM || 0}} articles or use the single special issue setting</ipub-col>
          </ipub-row>
        </div>
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_SPECIAL_ISSUE_APPLICATION_PORTAL')">
      <div class="ipub-h2 lin-h-40 mar-b-10">Edit a Special Issue</div>
      <div class="ipub-block">
        <ipub-radio :checked="displaySpecialIssue"
                    :disabled="!(user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_SPECIAL_ISSUE_APPLICATION_PORTAL.EDIT'))"
                    @change="(e) => {confirmSetting('SPECIAL_ISSUE_APPLY_SHOW',e)}"
                    label="Show Special Issue Application Portal" />
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_EDITORIAL_BOARD_APPLICATION_PORTAL')">
      <div class="ipub-h2 lin-h-40 mar-b-10">Editorial Board Application</div>
      <div class="ipub-block">
        <ipub-radio :checked="displayEb"
                    :disabled="!(user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_EDITORIAL_BOARD_APPLICATION_PORTAL.EDIT'))"
                    @change="(e) => {confirmSetting('EB_APPLY_SHOW',e)}"
                    label="Show Editorial Board Application Portal" />
      </div>
    </div>
    <div class="mar-b-20"
         v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_CONFERENCES')">
      <div class="ipub-h2 lin-h-40 mar-b-10">Conferences</div>
      <div class="ipub-block">
        <ipub-radio :checked="displayConference"
                    :disabled="!(user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_CONFERENCES.EDIT'))"
                    @change="(e) => {confirmSetting('CONFERENCES_SHOW',e)}"
                    label="Show Conferences" />
      </div>
    </div>

    <add-dialog :isVisable="isVisable"
                :inputData="inputData"
                @cancel="cancel"
                @confirm="confirmType"></add-dialog>
    <discount-voucher :isVisable="addDiscountVoucherVisable"
                      @cancel="cancel"
                      @confirm="confirmType"></discount-voucher>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
.min-line {
  width: 1px;
  height: 7px;
  background: #dbdfe3;
}
.line {
  width: 17px;
  height: 2px;
  background: $main_color;
}
</style>

<script>
import main from './main'
export default main
</script>
